import './styles.scss';
import React, {useEffect, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";
import {IResultsState, ISelected} from "../../../types/redux/result";
import {SelectedRecordsContext} from '../../../types/document';

/* Bootstrap */
import {Col, Container, Row} from "react-bootstrap";

/* Redux */
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";

/* Components */
import SelectResults from "../components/select-results";
import SortDropdown from "../components/sort-dropdown";
import Paging from "../components/search-paging";
import CardTools from "../card-tools";
import Utils from "../../../utils";
import ExpandAll from "../expand-all";
import {ISearchState} from "../../../types/redux/search";

const PageToolsTop = ():JSX.Element => {
  const resultsState: IResultsState = useSelector<RootState, IResultsState>(state => state.result);
  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);
  const [selectedRecords, setViewerRecords] = useState<any[]>([]);

  const [numOfResults, setNumOfResults] = useState<string | null>(null)

  useEffect(()=>{
    /* Converts results selected list of ids to list of records */
    const records: any[] = resultsState.selected_ids.map((selected: ISelected) => {
      return resultsState.results.find((record: any) => {
        return record.id === selected.id
      });
    })
    setViewerRecords(records);

    if (resultsState.searchResultMeta) {
      setNumOfResults(Utils.formatNumber(resultsState.searchResultMeta.num_found));
    } else {
      setNumOfResults(null)
    }
  }, [resultsState.selected_ids, resultsState.results, resultsState.searchResultMeta])


  return (
    <SelectedRecordsContext.Provider value={{records:selectedRecords}}>
      <Container className={'page-tools-top p-0 border border-1 rounded-2 bg-white'}>

        {/* Mobile */}
        <Container className={'d-lg-none mx-0 px-0'}>
          <Row className={'w-100 m-0 py-2'}>
            <Col className={'d-flex justify-content-between m-0 px-2'}>
              {/* Sort by */}
              <SortDropdown context={Constants.PAGE}/>

              {/* Pagination */}
              <Paging
                previous={' '}
                showPageInput={true}
                next={' '}
              />
            </Col>
          </Row>

          <Row className={'border-top m-0 py-2'}>
            <Col className={'m-0 p-0 d-flex text-nowrap px-2'}>
              {/* Card(s) Tools */}
              <CardTools context={Constants.TOOLBAR}/>
            </Col>
          </Row>

          <Row className={'border-top m-0 py-2 px-2 d-flex justify-content-between'}>
            <Col className={'m-0 p-0 d-flex text-nowrap px-2 '}>
              {/* Select Results */}
              <SelectResults />
            </Col>

            {/* Num of Results */}
            <Col className={'mt-2 text-end'}>
              {numOfResults &&
                <div className={'text-smaller'}>
                  {numOfResults}
                  <span className={'ms-1'}>Results</span>
                </div>}
            </Col>
          </Row>
        </Container>

        {/* Desktop */}
        <Container className={'m-0 p-0 d-none d-lg-block '}>
          <Row className={'d-flex justify-content-end w-100 py-2 px-1 mx-0 border-bottom'}>
            {/* Num of Results */}
            <Col className={'mt-2 '}>
              {numOfResults &&
                <div className={'text-smaller'}>
                {numOfResults}
                <span className={'ms-1'}>Results</span>
              </div>}
            </Col>

            <Col className={'text-nowrap d-flex justify-content-end'}>
              {/* Sort by */}
              <SortDropdown context={Constants.PAGE}/>

              {/* Pagination */}
              <Paging
                previous={'Previous'}
                showPageInput={true}
                next={'Next'}
              />
            </Col>
          </Row>

          <Row className={'bg-light rounded-bottom w-100 px-0 mx-0 text-nowrap'}>
            <Col className={'p-0 pt-1 d-flex text-nowrap'}>
              {/* Select Results */}
              <SelectResults />

              {/* Card(s) Tools */}
              <CardTools context={Constants.TOOLBAR}/>
            </Col>

            {/* Expand all records */}
            {((searchState.db_set === Constants.DOCUMENTS) ||
                (searchState.db_set === Constants.COLLECTIONS)) &&
              <Col className={'expand-all-col p-0 text-end me-0 '}>
                <ExpandAll/>
              </Col>}
          </Row>

        </Container>
      </Container>
    </SelectedRecordsContext.Provider>
  )
}
export default PageToolsTop;
